import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=A%20clean%20minimal%20cybersecurity%20concept%20image%20showing%20a%20laptop%20screen%20displaying%20warning%20signs%20with%20a%20shield%20icon%2C%20warm%20amber%20and%20soft%20gray%20tones%2C%20professional%20editorial%20style%20on%20light%20background%2C%20high%20detail%2C%20subtle%20gradients&width=800&height=480&seq=article-thumb-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=A%20minimal%20digital%20security%20image%20featuring%20a%20smartphone%20with%20a%20download%20warning%20symbol%2C%20surrounded%20by%20protective%20shield%20elements%2C%20warm%20amber%20accents%20on%20a%20clean%20light%20gray%20background%2C%20editorial%20tech%20style&width=800&height=480&seq=article-thumb-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=An%20abstract%20privacy%20protection%20concept%2C%20a%20silhouette%20with%20a%20lock%20icon%20overlay%2C%20soft%20green%20and%20warm%20gray%20tones%2C%20clean%20minimal%20composition%20on%20light%20background%2C%20editorial%20photography%20style&width=800&height=480&seq=article-thumb-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=A%20minimalist%20comparison%20image%20showing%20two%20smartphones%20side%20by%20side%2C%20one%20displaying%20a%20genuine%20checkmark%20and%20the%20other%20a%20warning%20cross%20mark%2C%20clean%20light%20background%20with%20soft%20teal%20and%20amber%20accents%2C%20editorial%20tech%20photography&width=800&height=480&seq=article-thumb-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=A%20minimal%20law%20and%20digital%20concept%2C%20a%20gavel%20next%20to%20a%20laptop%2C%20soft%20warm%20gray%20and%20subtle%20green%20tones%2C%20clean%20editorial%20style%20on%20light%20background%2C%20professional%20composition&width=800&height=480&seq=article-thumb-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=A%20minimal%20concept%20image%20of%20online%20scam%20awareness%2C%20a%20fishing%20hook%20disguised%20as%20a%20play%20button%20on%20a%20screen%2C%20warm%20amber%20warning%20tones%20on%20clean%20light%20background%2C%20editorial%20tech%20style%2C%20high%20detail&width=800&height=480&seq=article-thumb-6&orientation=landscape',
  '7': 'https://readdy.ai/api/search-image?query=A%20clean%20minimal%20tutorial%20concept%2C%20a%20laptop%20displaying%20security%20settings%20interface%20with%20step-by-step%20indicators%2C%20soft%20teal%20accents%20on%20light%20background%2C%20editorial%20tech%20photography%20style%2C%20high%20detail&width=800&height=480&seq=article-thumb-7&orientation=landscape',
  '8': 'https://readdy.ai/api/search-image?query=A%20minimal%20FAQ%20concept%20image%2C%20speech%20bubbles%20with%20question%20marks%20in%20a%20clean%20organized%20layout%2C%20warm%20amber%20and%20soft%20gray%20tones%2C%20editorial%20style%20on%20light%20background%2C%20high%20detail&width=800&height=480&seq=article-thumb-8&orientation=landscape',
};

export default function ArticleList() {
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">最新资讯</h2>
          <p className="text-sm text-foreground-500 mt-2">及时了解最新的安全动态和防范知识</p>
        </div>
        <Link
          to="/category/safety-tips"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
          >
            <div className="relative w-full h-48 overflow-hidden">
              <img
                src={articleImages[article.id]}
                alt={article.title}
                title={`${article.title} - 安全资讯`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 flex gap-2">
                {article.isHot && (
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">热门</span>
                )}
                {article.isNew && (
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">新发布</span>
                )}
              </div>
            </div>
            <div className="flex flex-col flex-1 p-4 md:p-5">
              <span className="text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">{article.category}</span>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                {article.summary}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}